import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_add_definition_examples = _resolveComponent("add-definition-examples")!
  const _component_add_definition_notes = _resolveComponent("add-definition-notes")!
  const _component_add_definition_external_links = _resolveComponent("add-definition-external-links")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": _ctx.word,
        "content-id": "add-definition",
        "menu-id": "add-definition-menu",
        type: "MANUAL_BACK",
        "manual-back-icon-handler": _ctx.back
      }, null, 8, ["header-title", "manual-back-icon-handler"]),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "add-definition"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "10",
                sizeLg: "8",
                sizeXl: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, { class: "margin-top-unset" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_title, null, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode(" Meaning ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_subtitle, { class: "tips" }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("span", { class: "material-icons" }, " tips_and_updates ", -1),
                              _createElementVNode("span", { class: "info" }, " An idea or a thing that a word represents ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            lines: "none",
                            class: "vocab-upsert-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_textarea, {
                                "auto-grow": true,
                                inputmode: "text",
                                autocapitalize: "sentences",
                                placeholder: "Type something",
                                value: _ctx.$props.definition ? _ctx.definition.meaning : _ctx.meaning,
                                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMeaning($event.detail.value as string)))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_add_definition_examples, {
                    ref: "AddDefinitionExamplesRef",
                    "existing-examples": _ctx.definition?.examples
                  }, null, 8, ["existing-examples"]),
                  _createVNode(_component_add_definition_notes, {
                    ref: "AddDefinitionNotesRef",
                    "existing-notes": _ctx.definition?.notes
                  }, null, 8, ["existing-notes"]),
                  _createVNode(_component_add_definition_external_links, {
                    ref: "AddDefinitionExternalLinksRef",
                    "existing-external-links": _ctx.definition?.externalLinks
                  }, null, 8, ["existing-external-links"]),
                  _createVNode(_component_ion_row, { class: "buttons-container" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        sizeXs: "6",
                        sizeSm: "4",
                        sizeMd: "2",
                        sizeLg: "2",
                        sizeXl: "2",
                        class: "cancel-button-container"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            fill: "outline",
                            color: "warning",
                            expand: "block",
                            class: "cancel-button",
                            onClick: _ctx.back
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode(" Cancel ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        sizeXs: "6",
                        sizeSm: "4",
                        sizeMd: "2",
                        sizeLg: "2",
                        sizeXl: "2",
                        class: "save-button-container"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            color: "success",
                            expand: "block",
                            class: "save-button",
                            onClick: _ctx.persist
                          }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode(" Save ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}